import light from '../themes/light.theme'

export function getCurrentTheme() {
  return light
}
